import { grid } from "./grid.js";
import { sky } from "./sky.js";
import { models } from "../models/models.js";
import { labels } from "../ui/labels.js";
import { store } from "../core/store.js";

const world = { public: {} };

world.drawSky = function drawSky(options) {
  if (options.type === "dynamic") {
    console.log("Drawing of Dynamic Sky Not Supported");
  } else {
    sky.createStatic(options);
  }
};

world.public.setScale = function updateScale(scale) {
  sky.scale(Number(scale));
  grid.setScale(Number(scale));
};

world.public.getScale = function getScale() {
  return sky.getScale();
};

world.public.getGridColorMode = function getGridColorMode() {
  return grid.getState().colorMode;
};

world.public.setGridTextureRepeat = function setGridTextureRepeat(val) {
  grid.setTiling(Number(val));
};

world.public.getGridTextureRepeat = function getGridTextureRepeat() {
  return grid.getState().tiling;
};

world.public.setGridLight = function setGridLight() {
  grid.setColorMode("light");
  store.requestRender();
};

world.public.setGridDark = function setGridDark() {
  grid.setColorMode("dark");
  store.requestRender();
};

world.public.toggleGrid = function toggleGrid() {
  const currentState = grid.getState();
  grid.setVisible(!currentState.visible);
  return grid.getState().visible;
};

world.public.getGridVisible = function getGridVisible() {
  return grid.getState().visible;
};

world.public.toggleGridVisibility = function toggleGridVisibility() {
  const visible = world.public.toggleGrid();

  if (typeof store.setUnsavedScene === "function") {
    store.setUnsavedScene();
  }

  return visible;
};

world.public.registerGridUpdate = function registerGridUpdate(callback) {
  return grid.subscribe(callback);
};

world.public.setGridVisible = function setGridVisible(visible) {
  const booleanVisible = visible === null ? true : Boolean(visible);
  grid.setVisible(booleanVisible);
  store.requestRender();
};


world.public.setGridVisibility = function setGridVisibility(visible) {
  const booleanVisible = visible === null ? true : Boolean(visible);
  grid.setVisible(booleanVisible);
  store.requestRender();
};

world.public.getDefaultGridVisibility = function getDefaultGridVisibility() {
  return grid.getInitialLoadedVisibility();
};

world.public.restoreGridVisibilityDefault = function restoreGridVisibilityDefault() {
  grid.setVisible(world.public.getDefaultGridVisibility());
  store.requestRender();
};

world.public.forceGridToDefault = function forceGridToDefault() {
  world.public.restoreGridVisibilityDefault();
};

// Subscribe to grid changes for automatic rendering
grid.subscribe((change) => {
  store.requestRender();
});

world.public.toggleHide = function toggleHide() {
  let skyModel = sky.staticSky;
  const gridVisible = grid.getState().visible;

  if (gridVisible && skyModel.visible) {
    grid.setVisible(false);
  } else if (!gridVisible && skyModel.visible) {
    skyModel.visible = false;
  } else {
    grid.setVisible(true);
    skyModel.visible = true;
  }
  store.requestRender();
};

world.public.setVisibleStart = function setVisibleStart() {
  models.setVisibleStartFromCurrentState();
  labels.setVisibleStartFromCurrentState();
  grid.setVisibleStartFromCurrentState();

  if (typeof store.setUnsavedScene === "function") {
    store.setUnsavedScene();
  }
};

world.public.showVisibleStart = function showVisibleStart() {
  models.showVisibleStart();
  labels.showVisibleStart();
  grid.showVisibleStart();
};

// Flexible serialization - can be configured for different use cases
world.serialize = function serialize(options = {}) {
  const forSceneState = options.forSceneState === true;
  let gridData;
  if (forSceneState) {
    gridData = grid.serializeSceneState();
  } else {
    // For full saves, grid visibility belongs to the initial scene rather
    // than the action currently rendered in the viewport. Other grid
    // settings remain global and are serialized from the current grid.
    const initialGridState = grid.getInitialLoadedState();
    gridData = {
      ...grid.serialize(),
      visible: typeof initialGridState?.visible === "boolean"
        ? initialGridState.visible
        : grid.getState().visible,
      scale: world.public.getScale(),
    };
  }

  return {
    grid: gridData,
    sky: sky.serialize(),
  };
};

// Flexible deserialization - applies only appropriate properties based on context
world.deserialize = function deserialize(data, options = {}) {
  if (!data) return;

  const fromSceneState = options.fromSceneState === true;

  if (fromSceneState) {
    grid.deserializeSceneState(data.grid);
    store.requestRender();
  } else if (data.grid) {
    // From full save: apply everything
    grid.deserialize(data.grid);

    if (data.grid.scale !== undefined) {
      world.public.setScale(data.grid.scale);
    }
  }

  if (data.sky && sky.deserialize) {
    sky.deserialize(data.sky);
  }
};

world.reset = function reset() {

  if (grid.resetForNewScene) {
    grid.resetForNewScene(); 
  } else if (grid.dispose) {
    grid.dispose();
  }

  if (sky.reset) {
    sky.reset();
  }
};

export { world };
